export const isPropValid = (prop: any) => {
  return (
    prop !== 'isOpen' &&
    prop !== 'minWidth' &&
    prop !== 'sideBarWidth' &&
    prop !== 'duration' &&
    prop !== 'isHovering' &&
    prop !== 'isBorderActive'
  );
};
